import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Typography,
  Box,
} from "@material-ui/core";
import CircularProgress from "@mui/material/CircularProgress";
import DeleteIcon from "@mui/icons-material/Delete";
import themeColorsDesingSystem from "assets/theme/ds-colors";

const STATUS_LABEL = {
  AguardandoEstoque: "Aguardando Estoque",
  Notificado: "Notificado",
  Vendido: "Vendido",
  Expirado: "Expirado",
};

function LineItem({ label, value }) {
  return (
    <Grid item xs={12} sm={6}>
      <Typography variant="body2" color="text.primary">
        {label}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {value || "-"}
      </Typography>
    </Grid>
  );
}

export default function DialogDetalhesProdutoDesejo({
  open,
  onClose,
  item,
  onDelete,
}) {
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (!open) setDeleting(false);
  }, [open, item?.idProdutoDesejoDigital]);

  if (!item) return null;

  function handleDialogClose(_event, reason) {
    if (
      deleting &&
      (reason === "backdropClick" || reason === "escapeKeyDown")
    ) {
      return;
    }
    onClose();
  }

  async function handleConfirmDelete() {
    if (!item.idProdutoDesejoDigital || !onDelete) return;
    if (
      !window.confirm(
        "Excluir este produto de desejo? Esta ação não pode ser desfeita.",
      )
    )
      return;
    setDeleting(true);
    try {
      await onDelete(item.idProdutoDesejoDigital);
    } finally {
      setDeleting(false);
    }
  }

  return (
    <Dialog open={open} onClose={handleDialogClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h3" color="primary">
          Detalhes do Produto Desejo
        </Typography>
      </DialogTitle>
      <DialogContent
        style={{
          padding: "0 1.5rem 1.5rem",
          pointerEvents: deleting ? "none" : "auto",
          opacity: deleting ? 0.65 : 1,
        }}
      >
        <Box style={{ paddingTop: 8 }}>
          <Grid container spacing={2}>
            {item.imagemProduto ? (
              <Grid item xs={12} style={{ textAlign: "center" }}>
                <Box
                  component="img"
                  src={item.imagemProduto}
                  alt=""
                  style={{
                    maxWidth: "100%",
                    maxHeight: 220,
                    objectFit: "contain",
                  }}
                />
              </Grid>
            ) : null}
            <LineItem
              label="ID do Produto Desejo"
              value={item.idProdutoDesejoDigital}
            />
            <LineItem
              label="Data de criação"
              value={item.dataCriacaoFormat || item.dataCriacao}
            />
            <LineItem label="Produto" value={item.descricaoProduto} />
            <LineItem label="Loja" value={item.nomeLoja} />
            <LineItem label="Cliente" value={item.nomeCliente} />
            <LineItem label="E-mail do cliente" value={item.emailCliente} />
            <LineItem label="Vendedor responsável" value={item.nomeVendedor} />
            <Grid item xs={12}>
              <Typography variant="body2" color="text.primary">
                Observações
              </Typography>
              <Typography
                variant="body1"
                color="text.secondary"
                style={{ whiteSpace: "pre-wrap" }}
              >
                {item.observacoes || "-"}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2" color="text.secondary">
                Status atual
              </Typography>
              <Box
                style={{
                  display: "inline-flex",
                  padding: "0.25rem 0.5rem",
                  borderRadius: "0.25rem",
                  backgroundColor:
                    themeColorsDesingSystem.gray?.background || "#f5f5f5",
                  color: themeColorsDesingSystem.gray?.main || "#616161",
                  marginTop: 4,
                }}
              >
                {STATUS_LABEL[item.status] || item.status}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        {onDelete ? (
          <Button
            onClick={handleConfirmDelete}
            color="secondary"
            variant="outlined"
            disabled={deleting}
            startIcon={
              deleting ? (
                <CircularProgress color="white" size={18} />
              ) : (
                <DeleteIcon />
              )
            }
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: 120,
            }}
          >
            {deleting ? "Excluindo…" : "Excluir"}
          </Button>
        ) : null}
        <Button
          onClick={onClose}
          color="primary"
          variant="contained"
          disabled={deleting}
        >
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
